import React, { useEffect } from 'react'
import mapboxgl from 'mapbox-gl'
import 'mapbox-gl/dist/mapbox-gl.css'
import '@mapbox/mapbox-gl-geocoder/dist/mapbox-gl-geocoder.css'
import { useGlobalState } from 'state'
import * as config from 'common/config'
import '@mapbox/mapbox-gl-geocoder/dist/mapbox-gl-geocoder.css'

mapboxgl.accessToken = config.mapboxAccessToken

export const Map = ({ children }: React.PropsWithChildren) => {
  const state = useGlobalState()

  const map = React.useRef<mapboxgl.Map | null>(null)
  const mapContainer = React.useRef<HTMLDivElement | null>(null)

  React.useEffect(() => {
    if (map.current) return
    if (!mapContainer.current) return

    map.current = new mapboxgl.Map({
      container: mapContainer.current,
      style: state.map.style.url,
      center: [state.map.lngLat.lng, state.map.lngLat.lat],
      minZoom: 5,
      maxZoom: 19,
      zoom: state.map.zoom,
      antialias: false
    })

    map.current.addControl(state.map.language)

    map.current.addControl(new mapboxgl.ScaleControl(), 'top-right')
    map.current.addControl(new mapboxgl.NavigationControl({showZoom: false, showCompass: true, visualizePitch: true}), 'top-right')

    map.current.on('moveend', () => {
      if (!map.current) return
      state.map.setLatLng(map.current.getCenter())
    })

    map.current.on('zoomend', () => {
      if (!map.current) return
      state.map.setZoom(map.current.getZoom())
      state.map.setIntZoom(Math.floor(map.current.getZoom()))
    })

    map.current.on('load', () => {
      if (!map.current) return
      state.map.setMapbox(map.current)
    })

    return () => {
      state.map.setMapbox(null)
    }
  }, [])

  useEffect(() => {
    if (!state.mapbox) return
    if (['3d', 'blank'].includes(state.map.style.id) && state.mapbox.hasControl(state.map.language)) {
      state.mapbox.removeControl(state.map.language)
    } else {
      if (!state.mapbox.hasControl(state.map.language)) {
        state.mapbox.addControl(state.map.language)
      }
    }
    state.mapbox.setStyle(state.map.style.url)
  }, [state.map.style])

  return (
    <>
      <div ref={mapContainer} style={{ width: '100%', height: '100%' }}></div>
      {children}
    </>
  )
}
